<template>
    <div>
        <loading-block v-if="dataIsLoading"></loading-block>
        <div v-else>
            <info-message status="success" v-if="messageSuccess">L'attestation a bien été envoyée</info-message>
            <uni-loading-button v-if="current" @click.native="changeYear" style="margin-bottom: 16px;" :is-disable="familyLoading"
                                text="Année précédente"></uni-loading-button>
            <uni-loading-button v-else @click.native="loadFamily" style="margin-bottom: 16px;" :is-disable="familyLoading"
                                text="Année en cours"></uni-loading-button>
            <div v-if="family.current_payments && family.current_payments.length > 0">
                <h1>Famille {{family.users[0].name.toUpperCase()}}</h1>
                <rich-table-recap @status="changeStatus($event)" :admin="true"
                                  :payments="family.current_payments"></rich-table-recap>
                <div v-if="family.current_payments[0].discount !== 0" class="reduction">Une réduction exceptionnelle de
                    {{getDiscount()}}€ a été
                    effectuée.
                </div>
                <div class="button-container" v-if="!allRecept() && currentFamily.isPayment">
                    <uni-loading-button @click.native="destroyPayments" class="button--secondary"
                                        :is-disable="loadReprepare" text="Re-préparer le paiement"></uni-loading-button>
                    <uni-loading-button @click.native="preparePayment" :is-disable="loadRecept"
                                        text="Paiement réceptionné"></uni-loading-button>
                </div>
                <div v-if="currentFamily.isPayment">
<!--                    <uni-loading-button style="margin-top: 1rem;" @click.native="openCeModal()"-->
<!--                                        :is-disable="loadCe"-->
<!--                                        text="Recevoir l'attestation CE par e-mail"></uni-loading-button>-->

                </div>
            </div>
            <div v-else class="payment-null">
                <div v-if="hasNoCourses()">
                    <p class="danger">Aucun danseur n'est inscrit à un cours.</p>
                </div>
                <div v-else>
                    <h3>Paiements</h3>
                    <uni-button v-if="currentFamily.isPayment" @click.native="openModal = true" class="button--secondary">Préparer le paiement
                    </uni-button>
                </div>
            </div>


            <div class="dancers">
                <h3>Danseurs</h3>
                <div class="dancer-container">
                    <router-link v-for="user in family.users.filter(el => el.is_dancer)"
                                 :to="{name: 'admin.users.edit', params: {id: user.id}}">
                        <p>{{$sexyName(user.firstname, user.name)}}</p>
                        <pill :bg-color="certificatColor(user)">Certificat médical</pill>
                        <p>Inscrit à {{user.current_courses ? user.current_courses.length : 0}} cours</p>
                    </router-link>
                </div>
            </div>

            <div class="infos">
                <h3>Informations complémentaires</h3>
                <div v-if="!currentFamily.isPayment" v-html="inputText"></div>
                <uni-text-area v-else placeholder="Informations complémentaires concernant la famille ..."
                               v-model="inputText"></uni-text-area>
                <uni-loading-button v-if="currentFamily.isPayment" @click.native="saveInput" style="margin-top: 16px;" :is-disable="inputDisable"
                                    text="Sauvegarder"></uni-loading-button>
            </div>

            <div class="danger" v-if="currentFamily.isPayment">
                <h3>Zone dangereuse</h3>
                <uni-loading-button style="width: auto; margin-top: 1rem;" text="Supprimer la famille"
                                    class="button--warning"
                                    @click.native="deleteUser">
                </uni-loading-button>
            </div>

            <pop-from-bottom title="Préparation du paiement" :open="openModal" @close="openModal = false">
                <template slot="content">
                    <div class="radio-container">
                        <div>
                            <h3 style="margin-bottom: 2rem;">Récurrence : </h3>
                            <beautifull-input-radio label="Annuel"
                                                    id="recurannual"
                            >
                                <input v-model="paymentRecurrence"
                                       type="radio"
                                       id="recurannual"
                                       value="annual"
                                >
                            </beautifull-input-radio>
                            <beautifull-input-radio label="Trimestriel"
                                                    id="recurtrim"
                            >
                                <input v-model="paymentRecurrence"
                                       type="radio"
                                       id="recurtrim"
                                       value="trim"
                                >
                            </beautifull-input-radio>
                        </div>
                        <div>
                            <h3 style="margin-bottom: 2rem;" v-if="paymentRecurrence !== ''">Type de paiement : </h3>
                            <div v-if="paymentRecurrence === 'annual'">
                                <beautifull-input-radio label="Virement bancaire"
                                                        id="annualTypeVirement"
                                >
                                    <input v-model="paymentType"
                                           type="radio"
                                           id="annualTypeVirement"
                                           value="virement"
                                    >
                                </beautifull-input-radio>
                                <beautifull-input-radio label="Chèque"
                                                        id="annualTypeChèque"
                                >
                                    <input v-model="paymentType"
                                           type="radio"
                                           id="annualTypeChèque"
                                           value="cheque"
                                    >
                                </beautifull-input-radio>
                                <beautifull-input-radio label="Espèce"
                                                        id="annualTypeCash"
                                >
                                    <input v-model="paymentType"
                                           type="radio"
                                           id="annualTypeCash"
                                           value="cash"
                                    >
                                </beautifull-input-radio>
                            </div>
                            <div v-if="paymentRecurrence === 'trim'">
                                <beautifull-input-radio label="Chèque"
                                                        id="trimTypeChèque"
                                >
                                    <input v-model="paymentType"
                                           type="radio"
                                           id="trimTypeChèque"
                                           value="cheque"
                                    >
                                </beautifull-input-radio>
                            </div>
                        </div>
                        <div>
                            <h3 v-if="paymentRecurrence !== '' && paymentType !== ''" style="margin-bottom: 1rem;">
                                Réduction :</h3>
                            <uni-input v-if="paymentRecurrence !== '' && paymentType !== ''" placeholder="0€"
                                       v-model="discount"
                                       style="width: 100px;"></uni-input>
                        </div>


                    </div>
                </template>
                <template slot="bottom">
                    <uni-loading-button @click.native="createPayment" :is-disable="loadPayment" style="width: auto;"
                                        v-if="paymentRecurrence !== '' && paymentType !== ''"
                                        text="Enregistrer les paiements"></uni-loading-button>
                </template>
            </pop-from-bottom>
            <pop-from-bottom title="Attestation CE" :open="ceModal" @close="ceModal = false">
                <template slot="content">
                    <div>
                        <uni-input-container label="adresse e-mail" id="email">
                            <uni-input id="email" v-model="email" :val="email" width="auto"></uni-input>
                        </uni-input-container>
                        <uni-loading-button @click.native="downloadCe()" :is-disable="buttonCe"
                                            text="Envoyer"></uni-loading-button>
                    </div>
                </template>
                <template slot="bottom">

                </template>
            </pop-from-bottom>
        </div>
    </div>
</template>

<script>

    //math.floor pour le plus petit
    // math.ceil pour le plus grand

    import LoadingBlock from "../../components/c-blocks/LoadingBlock";
    import RichTableRecap from "../../components/c-blocks/richTableRecap";
    import UniCtaLink from "../../components/a-elements/UniCtaLink";
    import UniLoadingButton from "../../components/b-patterns/UniLoadingButton";
    import Pill from "../../components/a-elements/pill";
    import PopFromBottom from "../../components/c-blocks/PopFromBottom";
    import UniButton from "../../components/a-elements/UniButton";
    import BeautifullInputRadio from "../../components/a-elements/BeautifullInputRadio";
    import UniInput from "../../components/a-elements/UniInput";
    import UniTextArea from "../../components/a-elements/uniTextArea";
    import UniInputContainer from "../../components/a-elements/UniInputContainer";
    import {mapGetters} from "vuex";
    import InfoMessage from "../../components/a-elements/InfoMessage";

    export default {
        name: "adminFamiliesEdit",
        components: {
            InfoMessage,
            UniInputContainer,
            UniTextArea,
            UniInput,
            BeautifullInputRadio,
            UniButton, PopFromBottom, Pill, UniLoadingButton, UniCtaLink, RichTableRecap, LoadingBlock
        },
        computed: {
            ...mapGetters({currentFamily: 'currentFamily'})
        },
        data() {
            return {
                messageSuccess: false,
                buttonCe: false,
                inputDisable: false,
                inputText: '',
                dataIsLoading: true,
                family: {},
                loadRecept: false,
                loadPayment: false,
                loadReprepare: false,
                loadCe: false,
                openModal: false,
                ceModal: false,
                paymentRecurrence: '',
                paymentType: '',
                discount: 0,
                email: '',
                current: true,
                familyLoading: false
            }
        },
        methods: {
            changeYear() {
                this.familyLoading = true
                this.dataIsLoading = true
                this.current = false
                this.$http.get('/admin/families/' + this.family.id + '/last-year')
                .then(res => {
                    this.family = res.data
                    this.family.current_payments = res.data.last_year_payments
                    this.inputText = res.data.infos
                    this.dataIsLoading = false
                    this.familyLoading = false
                    this.email = res.data.email
                })

            },

            saveInput() {
                this.inputDisable = true
                this.$http.put('/admin/families/' + this.family.id, {family: {infos: this.inputText}})
                    .then(response => {
                        this.inputDisable = false
                    })
                    .catch(error => {
                        if (this.$isSignatureExpired(error.response.data.message)) {
                            this.$store.dispatch('logout')
                            this.$router.push({name: 'Login', params: {q: 'expired'}})
                        }
                    })
            },
            deleteUser() {
                if (confirm("La suppression est définitive. Les danseurs, responsables légaux, certificats médicaux et paiements seront également supprimés.")) {

                    this.$deleteModel('families', this.family.id)
                        .then(response => {
                            this.$router.push({name: 'admin.index'})
                        })

                }
            },
            changeStatus(e) {
                this.family.current_payments = e.current_payments
            },
            destroyPayments() {
                this.loadReprepare = true
                this.$adminDestroyPayments(this.family.id)
                    .then(data => {
                        this.family = data
                        this.loadReprepare = false
                        this.openModal = true
                    })
            },
            allRecept() {
                let rec = true
                this.family.current_payments.forEach(el => {
                    if (el.status === false) {
                        rec = false
                    }
                })
                return rec
            },
            preparePayment() {
                this.loadRecept = true
                this.$adminReceptPayments(this.family.id)
                    .then(data => {
                        this.family.current_payments = data
                        this.loadRecept = false
                    })
            },
            getDiscount() {
                let total = 0
                this.family.current_payments.forEach(el => {
                    total += el.discount
                })

                return total
            },
            hasNoCourses() {
                let total = 0
                this.family.users.forEach(user => {
                    total += user.current_courses ? user.current_courses.length : 0
                })
                return total === 0
            },
            createPayment() {
                this.loadPayment = true

                this.$adminCreatePayments(this.family.id, this.paymentType, this.paymentRecurrence, this.discount)
                    .then(data => {
                        this.family.current_payments = data
                        this.openModal = false
                        this.loadPayment = false
                    })


            },
            certificatColor(user) {
                if (user.medical_certificate) {
                    if (user.medical_certificate.year) {
                        return "pill-success"
                    } else {
                        return "pill-warning"
                    }
                } else {
                    return "pill-danger"
                }
            },
            downloadCe() {
                this.buttonCe = true

                this.$http.get('/admin/families/' + this.family.id + '/get-attestation-ce?email=' + this.email + '&id=' + this.family.id, this.$getHeaders())
                    .then(response => {

                        this.buttonCe = false
                        this.ceModal = false
                        this.messageSuccess = true
                        window.setTimeout(() => {
                            this.messageSuccess = false
                        }, 5000)
                    })
                    .catch(error => {
                        if (this.$isSignatureExpired(error.response.data.message)) {
                            this.$store.dispatch('logout')
                            this.$router.push({name: 'Login', params: {q: 'expired'}})
                        }
                    })
            },
            openCeModal() {
                this.ceModal = true
            },
            loadFamily() {
                this.dataIsLoading = true
                this.familyLoading = true
                this.current = true
                this.$adminGetFamily(this.$route.params.id)
                    .then(data => {
                        this.family = data
                        this.inputText = data.infos
                        this.dataIsLoading = false
                        this.familyLoading = false

                        this.email = data.email

                    })
            }
        },
        created() {
            this.loadFamily()
        },
        beforeRouteUpdate(to, from, next) {
            this.dataIsLoading = true
            this.$adminGetFamily(to.params.id)
                .then(data => {
                    this.family = data
                    this.inputText = data.infos
                    this.dataIsLoading = false

                    this.email = data.email
                })
            next()
        }
    }
</script>

<style scoped lang="scss">

    .reduction {
        background: var(--color-grey-light-2);
        border-radius: var(--radius-big);
        padding: 16px 24px;
    }

    .button-container {
        margin-top: 1rem;
        display: grid;
        grid-template-columns: 1fr;
        gap: 1rem;
    }

    .dancers {
        margin-top: 2rem;
    }

    .dancer-container {
        margin-top: 1rem;
        display: grid;
        grid-template-columns: 1fr;
        gap: 1rem;

        > a {
            padding: 12px 20px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            background: var(--color-grey-light-2);
            border-radius: var(--radius-big);

            > * {
                margin: 0;
                width: 50%;
            }

            > div {
                width: 120px;
            }

        }
    }

    .infos {
        margin-top: 32px;

        h3 {
            margin-bottom: 16px;
        }

        textarea {
            height: 200px;
        }
    }

    .danger {
        margin-top: 32px;
    }

    @include screen-m {

        .dancer-container {
            grid-template-columns: 1fr 1fr;
        }

        .radio-container {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 1rem;
        }
        .payment-null {
            > div {
                display: flex;
                justify-content: space-between;
            }

        }

        .button-container {
            grid-template-columns: 1fr 1fr;
            align-items: center;

            > *:first-child {
                height: 100%;
                line-height: 32px;
                margin: 0;
            }
        }
    }

</style>
